/* Hook encargado de hacer la consulta a la base y 
traer la cotizacion a partir de su id

Autor: Benjamín León
Fecha: 2024-08-16
*/
import { useState } from 'react'

import EstimateDet from '../interfaces/EstimateDet.ts'
import { customFetch } from '../utils/customFetch.ts'

import { makeUrlEstimate } from './connectionData.tsx'

const useEstimateFetcher = () => {
  const [errorEstimate, setErrorEstimate] = useState<Error | null>(null)
  const [loading, setLoading] = useState<boolean>(false)

  const fetchEstimate = async (id: string) => {
    setLoading(true)
    try {
      const apiUrl = makeUrlEstimate(id)
      const data = await customFetch<EstimateDet>(apiUrl)

      setErrorEstimate(null)

      return data
    } catch (err) {
      // Assert the error as an instance of Error
      if (err instanceof Error) {
        setErrorEstimate(err)
      } else {
        setErrorEstimate(new Error('An unknown error occurred'))
      }

      return null
    } finally {
      setLoading(false)
    }
  }

  // Exponemos estas variables al exterior
  return { errorEstimate, loading, fetchEstimate }
}
export default useEstimateFetcher
